import styled from "styled-components";
import { theme } from "@themes";

export const MediumWrapper = styled.div`
  display: grid;
  padding: 0.4rem;

  input,
  select {
    padding: 0.5em;
    border: 1px solid ${({ theme }) => theme.neutral.gray[900]};
    outline: 0;
    width: 35%;
    border-radius: 4px;
    box-sizing: border-box;
    font-size: 14px;
    margin-left: 4px;
    color: ${({ theme }) => theme.primaryIconColor};
  }

  input::placeholder {
    font-size: 12px;
  }
`;

export const HorizontalLines = styled.div`
  hr {
    height: 0px;
    left: 852px;
    top: 578px;
    border: 1px solid ${({ theme }) => theme.border.light};
  }
`;

export const SizeFace = styled.div`
  display: inline-block;
  width: 20%;

  svg {
    width: 60% !important;
  }
`;

export const NeutralFace = styled.span`
  circle {
    fill: ${({ colorBackground }) => colorBackground} !important;
  }
  path {
    fill: ${({ colorBackground }) => colorBackground} !important;
  }
  h3 {
    font-size: 1.3em;
  }
`;

export const GeneralStyle = styled.div`
  position: relative;
  align-items: center;
  justify-self: center;
  display: grid;
  margin: 1em;
  ${({ isDependent }) =>
    isDependent && "border-left: #0087ff solid !important"};
  max-width: 710px;
  grid-template-columns: 1fr;
  font-size: 14px;
  border-radius: 5px;
  padding: 1em 2em;
  word-break: break-word;
  opacity: 0.95;
  width: 100%;
  box-shadow: ${({ editable }) =>
    editable && "0px 0px 10px rgba(0, 0, 0, 0.3)"};
  border-radius: 4px;
  background: ${(props) =>
    props.colorBackground === "#f9f9f9"
      ? "transparent"
      : props.colorBackground};
  @media only screen and (max-width: 495px) {
    grid-template-columns: 100%;
  }
  hr {
    width: 100%;
    margin-top: 1rem;
    margin-bottom: 1rem;
    border: 0;
    border-top: 1px solid ${({ theme }) => theme.neutral.gray[200]};
    background: "#f9f9f9";
  }
  .ColorPicker {
    width: 50% !important;
    height: 100% !important;
    border: 1px solid ${({ theme }) => theme.neutral.gray[900]} !important;
    padding: 0.01em !important;
  }

  .DivPadre {
    text-align: center;
    padding-top: 10px;
    padding-bottom: 20px;
    background-color: ${(props) =>
      props.colorBackground !== "#f9f9f9"
        ? "rgba(255,255,255,0.6)"
        : props.colorBackground};
    margin-top: 20px;
  }

  .DivHijo {
    display: inline-block;
    width: 20%;
  }

  h3 {
    margin: 0 0 10px 0 !important;
  }

  .MargenDiv {
    margin-top: 10px;
    margin-bottom: 10px;
  }

  .DropdownFace {
    background: none !important;
    height: 100% !important;
    border: 1px solid ${({ theme }) => theme.neutral.gray[900]} !important;
    width: 55% !important;
    color: ${({ theme }) => theme.neutral.black} !important ;
    padding: 0 !important;
  }

  .DropdownFace:hover {
    box-shadow: none !important;
    -webkit-transform: none !important;
    -ms-transform: none !important;
    transform: none !important;
    cursor: pointer !important;
  }

  .HeightFace {
    width: 60% !important;
  }

  .InputNumber {
    width: 100% !important;
  }

  .HeightIconTitle {
    width: 5% !important;
  }

  .Alignbuttons {
    width: 100%;
    margin-top: 30px;
    display: flex;
    justify-content: flex-end;
  }

  .CustomInput {
    padding-right: 0px !important;
    padding-left: 0px !important;
    margin-bottom: 0px !important;
    justify-content: center !important;
  }

  .CustomLabel {
    display: flex;
    justify-content: center;
    margin-top: 7px;
  }

  .CustomInputQuestion {
    padding-right: 0px !important;
    padding-left: 0px !important;
  }

  .CustomInputOrder {
    padding-right: 35px !important;
    padding-left: 0px !important;
  }

  .CustomInputCheck {
    padding-right: 0px !important;
    width: 10% !important;
  }

  .CustomInput-value {
    display: flex;
    justify-content: center;
    height: 35px;
  }

  .input-questions {
    height: 37px !important;
    width: 100%;
  }

  .modify-dropdown-menu {
    min-width: 4em;
  }

  :hover .overlay-option {
    opacity: 1;
  }
  .overlay-option {
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    width: 100%;
    height: 100%;
    opacity: 0;
    background-color: rgba(46, 46, 46, 0.2);
  }

  .bottom-buttons {
    position: absolute;
    bottom: 0;
    right: 0;
    width: 100%;
    @media only screen and (max-width: 475px) {
      display: flex;
      flex-wrap: wrap;
      justify-content: space-around;
    }
  }
`;

export const EditSection = styled.div`
  align-items: center;
  display: grid;
  grid-template-columns: 1fr;
  font-size: 14px;
  border-radius: 5px;
  word-break: break-word;
  background: "#f9f9f9";
  hr {
    width: 100%;
    margin-top: 1rem;
    margin-bottom: 1rem;
    border: 0;
    border-top: 1px solid ${({ theme }) => theme.neutral.gray[200]};
  }
`;

export const UpperWrapper = styled.div`
  display: grid;
  padding: 0.4rem;
  grid-template-columns: 1fr;
  align-items: center;
  grid-gap: 1em;

  input,
  select {
    padding: 0.5em;
    width: 100%;
    border: 1px solid ${({ theme }) => theme.neutral.gray[900]};
    outline: 0;
    border-radius: 4px;
    box-sizing: border-box;
    font-size: 14px;
    color: ${({ theme }) => theme.primaryIconColor};
  }

  input::placeholder {
    font-size: 12px;
  }

  #mText {
    grid-column: 1;
    grid-row: 2;
  }
`;

export const VSection = styled.div`
  display: grid;
  grid-template-columns: 1fr 1.5fr;
  align-items: center;
  @media only screen and (max-width: 495px) {
    grid-template-columns: 1fr;
  }
  input {
    justify-self: left;
    height: 2em;
    width: 100%;
    border: 1px solid rgba(240, 240, 240, 1);
    background: RGBA(250, 250, 250, 1);
    outline: none;
    padding: 1em 0.5em;
    font-size: small;
    border-radius: 3px;
  }
  input[type="checkbox"] {
    box-sizing: border-box;
    padding: 0;
    width: auto;
    justify-self: flex-start;
    align-self: center;
  }
  .MuiFormControlLabel-root svg {
    height: 15px;
    width: 15px;
  }

  .MuiFormControlLabel-label {
    font-size: 13px;
  }

  .MuiCheckbox-colorSecondary.Mui-checked {
    color: ${({ theme }) => theme.primary.purple};
  }
`;

export const QuestionWrapper = styled.div`
  display: grid;
  padding: 0.4em;
  align-items: center;

  label {
    font-weight: 700;
  }

  textarea {
    padding: 1rem;
    width: 100%;
    height: 6em;
    outline: 0;
    border: none;
    background: ${({ theme }) => theme.background.light};
    border-radius: 4px;
    box-sizing: border-box;
    font-size: small;
    color: ${({ theme }) => theme.primaryIconColor};
    resize: none;
  }
`;
export const SelectsSection = styled.div`
  display: grid;
  padding: 0.4em;
  grid-gap: 1em;

  label {
    font-weight: 700;
    font-size: small;
  }
`;
export const LowerWrapper = styled.div`
  display: grid;
  padding: 0.4em;
  align-items: center;
`;

export const ContainerButtons = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: row;
  padding-top: 25px;
  width: 100%;
  @media only screen and (max-width: 495px) {
    flex-direction: column;
    align-items: center;
  }
  .left-container {
    margin-left: 20px;
    display: flex;
    width: 70%;
    @media only screen and (max-width: 495px) {
      width: fit-content;
    }
  }
  .right-container {
    display: flex;
    width: 30%;
    justify-content: end;
  }
`;

export const ContainerSelectOptions = styled.div`
  padding: 20px;
`;

export const ThirdOptions = styled.label`
  margin-left: 4px;
  font-weight: 700;
`;

export const ContainerTitle = styled.div`
  font-family: "Noto Sans", sans-serif;
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 22px;
  color: ${({ theme }) => theme.primary.purple};
`;

export const EditButton = styled.button`
    background: ${({ theme }) => theme.button.primary};
  border-radius: 4px;
  border: none;
  float: right;
  height: 40px;
  text-align: center;
  color: white;
  max-width: 80px;
  max-height: 31px;
  @media only screen and (max-width: 475px) {
    position: static;
    font-size: 12px;
  }
`;

export const DeleteButton = styled.button`
  border: none;
  background-color: ${({ theme }) => theme.primaryBackgroundLight};
  border-radius: 4px;
  height: 40px;
  text-align: center;
  color: ${({ theme }) => theme.neutral.gray[2600]};
  float: right;
  font-size: 14px;
  font-weight: 500;
  max-width: 80px;
  max-height: 31px;
  &:hover {
    opacity: 0.9;
  }
  @media only screen and (max-width: 475px) {
    position: static;
    font-size: 12px;
  }
`;
export const CloneButton = styled.button`
  border: none;
  background-color: ${({ theme }) => theme.primaryBackgroundLight};
  border-radius: 4px;
  height: 31px;
  max-height: 31px;
  text-align: center;
  color: ${({ theme }) => theme.neutral.black};
  float: left;
  font-size: 14px;
  font-weight: 500;
  max-width: 90px;
  left: 0;
  position: absolute;
  &:hover {
    opacity: 0.9;
  }
  svg {
    width: auto !important;
    height: auto !important;
  }
  @media only screen and (max-width: 475px) {
    position: static;
    font-size: 12px;
  }
`;
export const SaveToBank = styled.button`
    background: ${({ theme }) => theme.button.primary};
  border-radius: 4px;
  border: none;
  float: left;
  height: 40px;
  text-align: center;
  color: white;
  max-width: 110px;
  max-height: 31px;
  position: absolute;
  left: 120px;
  @media only screen and (max-width: 475px) {
    position: static;
    font-size: 12px;
  }
`;

export const TooltipCheckSection = styled.div`
  input[type="checkbox"] {
    box-sizing: border-box;
    padding: 0;
    width: auto;
    justify-self: flex-start;
    align-self: center;
  }

  .MuiFormControlLabel-root svg {
    height: 20px;
    width: 20px;
    color: black;
  }

  .MuiFormControlLabel-label {
    font-size: 13px;
    font-weight: bold;
  }

  .MuiCheckbox-colorSecondary.Mui-checked {
    color: black;
  }
`;

export const TooltipDescriptionContainer = styled.div`
  textarea {
    justify-self: left;
    height: 2em;
    width: 100%;
    border: 1px solid ${({ theme }) => theme.neutral.gray[900]};
    background: white;
    outline: none;
    padding: 1em 0.5em;
    font-size: small;
    border-radius: 3px;
  }
`;
